import { render } from "./AppFooter.vue?vue&type=template&id=605c6e49"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=605c6e49&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__